"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var InputMaskChildrenWrapper = function (_React$Component) {
  (0, _inherits2["default"])(InputMaskChildrenWrapper, _React$Component);
  var _super = _createSuper(InputMaskChildrenWrapper);
  function InputMaskChildrenWrapper() {
    (0, _classCallCheck2["default"])(this, InputMaskChildrenWrapper);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(InputMaskChildrenWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        props = (0, _objectWithoutProperties2["default"])(_this$props, ["children"]);
      return _react["default"].cloneElement(children, props);
    }
  }]);
  return InputMaskChildrenWrapper;
}(_react["default"].Component);
exports["default"] = InputMaskChildrenWrapper;
InputMaskChildrenWrapper.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InputMaskChildrenWrapper"
};
if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["InputField/mask/children-wrapper.js"] = {
    name: "InputMaskChildrenWrapper",
    docgenInfo: InputMaskChildrenWrapper.__docgenInfo,
    path: "InputField/mask/children-wrapper.js"
  };
}